export const licenseModuleBase = value => value !== null && value !== undefined;

export const licenseModuleWidget = value => Boolean(value & 1);

export const licenseModuleMessages = value => Boolean(value & 2);

export const licenseModuleAccessControl = value => Boolean(value & 4);